import React from 'react'

const PARTNERS = [
  { file: 'enva.png', alt: "École nationale vétérinaire d'Alfort" },
  { file: 'oniris.png', alt: 'Oniris VetAgroBio Nantes' },
  { file: 'arginine.png', alt: 'Arginine Formation' },
  { file: 'sevetys.jpg', alt: 'Sevetys' },
  { file: 'evidensia.jpg', alt: 'IVC Evidensia' },
  { file: 'anicura.jpg', alt: 'AniCura' },
]

const TrustStrip = () => (
  <section className="trust-strip">
    <div className="vt-shell">
      {/* Stats row */}
      <div className="trust-strip__stats">
        <div>
          <div className="trust-strip__n">6 500+</div>
          <div className="trust-strip__l">prescriptions émises</div>
        </div>
        <div>
          <div className="trust-strip__n">150+</div>
          <div className="trust-strip__l">cliniques utilisatrices</div>
        </div>
        <div>
          <div className="trust-strip__n">Depuis 2019</div>
          <div className="trust-strip__l">en usage clinique quotidien</div>
        </div>
      </div>

      <div className="trust-strip__meta">
        <span className="trust-strip__born">Né à Alfort et VetAgro Sup Lyon.</span>
        <span className="trust-strip__std">Fondé sur FEDIAF, AAFCO & la littérature scientifique.</span>
      </div>

      <div className="trust-strip__divider" />

      <p className="trust-strip__label">Ils nous font confiance</p>
      <div className="trust-strip__logos">
        {PARTNERS.map((p, i) => (
          <span className="trust-strip__logo-item" key={i} title={p.alt}>
            <img src={`img/partners/${p.file}`} alt={p.alt} />
          </span>
        ))}
      </div>
    </div>
  </section>
)

export default TrustStrip
